var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "tr",
    {
      staticClass: "entry-row",
      class: {
        "h-table__row--warning": !_vm.entry.isIssued,
        "h-table__row--error": _vm.entry.isExpired,
      },
    },
    [
      _c("td", { staticClass: "entry-row__name" }, [
        _c(
          "div",
          {
            class: {
              "greyed-out": !_vm.entry.isIssued,
            },
          },
          [
            _vm._v(
              " " +
                _vm._s(_vm.entry.item.serialNumber || "—") +
                " / " +
                _vm._s(_vm.entry.item.name || "—") +
                " "
            ),
          ]
        ),
        _c("div", { staticClass: "entry-row__type greyed-out" }, [
          _vm._v(" " + _vm._s(_vm.entry.type.name) + " "),
        ]),
      ]),
      _c("td", [
        _vm._v(" " + _vm._s(_vm.entry.type.model || "—") + " / "),
        _c(
          "span",
          {
            class: {
              "greyed-out": !_vm.entry.isIssued && !_vm.entry.item.model,
            },
          },
          [_vm._v(" " + _vm._s(_vm.entry.item.model || "—") + " ")]
        ),
      ]),
      _c("td", [
        _vm._v(" " + _vm._s(_vm.entry.item.status || "Не выдан") + " "),
      ]),
      _c("td", [_vm._v(" " + _vm._s(_vm.entry.item.issuedAt) + " ")]),
      _c(
        "td",
        [
          _vm.entry.isIssued
            ? [
                _vm.entry.item.issuer.id
                  ? _c(
                      "a",
                      {
                        attrs: {
                          href: `/index.php/?r=redesign#/personal-employee/${_vm.entry.item.issuer.id}/summary`,
                          target: "_blank",
                        },
                      },
                      [_vm._v(" " + _vm._s(_vm.entry.item.issuer.name) + " ")]
                    )
                  : [_vm._v(" " + _vm._s(_vm.entry.item.issuer.name) + " ")],
              ]
            : _vm._e(),
        ],
        2
      ),
      _c("td", [
        _vm._v(
          " " +
            _vm._s(
              _vm.entry.isIssued ? _vm.entry.item.willExpireAt || "—" : ""
            ) +
            " "
        ),
      ]),
      _c(
        "td",
        [
          _vm.entry.type.responsible
            ? _c(
                "a",
                {
                  attrs: {
                    href: `?r=redesign#/personal-employee/${_vm.entry.type.responsible.id}/summary`,
                    target: "_blank",
                  },
                },
                [_vm._v(" " + _vm._s(_vm.entry.type.responsible.name) + " ")]
              )
            : [_vm._v(" — ")],
        ],
        2
      ),
      _c("td", [_vm._t("default")], 2),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }